module.exports = __webpack_public_path__ + "static/scale-model-of-dearborn-station-in-chicago-illinois-fd891119c39dde0d7741286a2389e4c1.png";